function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

import _regeneratorRuntime from "@babel/runtime/regenerator";

function _wrapAsyncGenerator(fn) { return function () { return new _AsyncGenerator(fn.apply(this, arguments)); }; }

function _AsyncGenerator(gen) { var front, back; function send(key, arg) { return new Promise(function (resolve, reject) { var request = { key: key, arg: arg, resolve: resolve, reject: reject, next: null }; if (back) { back = back.next = request; } else { front = back = request; resume(key, arg); } }); } function resume(key, arg) { try { var result = gen[key](arg); var value = result.value; var wrappedAwait = value instanceof _AwaitValue; Promise.resolve(wrappedAwait ? value.wrapped : value).then(function (arg) { if (wrappedAwait) { resume(key === "return" ? "return" : "next", arg); return; } settle(result.done ? "return" : "normal", arg); }, function (err) { resume("throw", err); }); } catch (err) { settle("throw", err); } } function settle(type, value) { switch (type) { case "return": front.resolve({ value: value, done: true }); break; case "throw": front.reject(value); break; default: front.resolve({ value: value, done: false }); break; } front = front.next; if (front) { resume(front.key, front.arg); } else { back = null; } } this._invoke = send; if (typeof gen.return !== "function") { this.return = undefined; } }

_AsyncGenerator.prototype[typeof Symbol === "function" && Symbol.asyncIterator || "@@asyncIterator"] = function () { return this; };

_AsyncGenerator.prototype.next = function (arg) { return this._invoke("next", arg); };

_AsyncGenerator.prototype.throw = function (arg) { return this._invoke("throw", arg); };

_AsyncGenerator.prototype.return = function (arg) { return this._invoke("return", arg); };

function _awaitAsyncGenerator(value) { return new _AwaitValue(value); }

function _AwaitValue(value) { this.wrapped = value; }

function _asyncIterator(iterable) { var method; if (typeof Symbol !== "undefined") { if (Symbol.asyncIterator) method = iterable[Symbol.asyncIterator]; if (method == null && Symbol.iterator) method = iterable[Symbol.iterator]; } if (method == null) method = iterable["@@asyncIterator"]; if (method == null) method = iterable["@@iterator"]; if (method == null) throw new TypeError("Object is not async iterable"); return method.call(iterable); }

function _asyncGeneratorDelegate(inner, awaitWrap) { var iter = {}, waiting = false; function pump(key, value) { waiting = true; value = new Promise(function (resolve) { resolve(inner[key](value)); }); return { done: false, value: awaitWrap(value) }; } ; iter[typeof Symbol !== "undefined" && Symbol.iterator || "@@iterator"] = function () { return this; }; iter.next = function (value) { if (waiting) { waiting = false; return value; } return pump("next", value); }; if (typeof inner.throw === "function") { iter.throw = function (value) { if (waiting) { waiting = false; throw value; } return pump("throw", value); }; } if (typeof inner.return === "function") { iter.return = function (value) { if (waiting) { waiting = false; return value; } return pump("return", value); }; } return iter; }

import getFilesAndDirectoriesFromDirectory from './getFilesAndDirectoriesFromDirectory.js';
/**
 * Polyfill for the new (experimental) getAsFileSystemHandle API (using the popular webkitGetAsEntry behind the scenes)
 * so that we can switch to the getAsFileSystemHandle API once it (hopefully) becomes standard
 */

function getAsFileSystemHandleFromEntry(entry, logDropError) {
  if (entry == null) return entry;
  return {
    // eslint-disable-next-line no-nested-ternary
    kind: entry.isFile ? 'file' : entry.isDirectory ? 'directory' : undefined,
    name: entry.name,
    getFile: function getFile() {
      return new Promise(function (resolve, reject) {
        return entry.file(resolve, reject);
      });
    },
    values: function values() {
      return _wrapAsyncGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var directoryReader, entries;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                // If the file is a directory.
                directoryReader = entry.createReader();
                _context.next = 3;
                return _awaitAsyncGenerator(new Promise(function (resolve) {
                  getFilesAndDirectoriesFromDirectory(directoryReader, [], logDropError, {
                    onSuccess: function onSuccess(dirEntries) {
                      return resolve(dirEntries.map(function (file) {
                        return getAsFileSystemHandleFromEntry(file, logDropError);
                      }));
                    }
                  });
                }));

              case 3:
                entries = _context.sent;
                return _context.delegateYield(_asyncGeneratorDelegate(_asyncIterator(entries), _awaitAsyncGenerator), "t0", 5);

              case 5:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    }
  };
}

function createPromiseToAddFileOrParseDirectory(_x, _x2, _x3) {
  return _createPromiseToAddFileOrParseDirectory.apply(this, arguments);
}
/**
 * Load all files from data transfer, and recursively read any directories.
 * Note that IE is not supported for drag-drop, because IE doesn't support Data Transfers
 *
 * @param {DataTransfer} dataTransfer
 * @param {*} logDropError on error
 */


function _createPromiseToAddFileOrParseDirectory() {
  _createPromiseToAddFileOrParseDirectory = _wrapAsyncGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(entry, relativePath, lastResortFile) {
    var file, _iteratorAbruptCompletion, _didIteratorError, _iteratorError, _iterator, _step, handle;

    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            if (lastResortFile === void 0) {
              lastResortFile = undefined;
            } // For each dropped item, - make sure it's a file/directory, and start deepening in!


            if (!(entry.kind === 'file')) {
              _context2.next = 16;
              break;
            }

            _context2.next = 4;
            return _awaitAsyncGenerator(entry.getFile());

          case 4:
            file = _context2.sent;

            if (!(file != null)) {
              _context2.next = 11;
              break;
            }

            file.relativePath = relativePath ? "".concat(relativePath, "/").concat(entry.name) : null;
            _context2.next = 9;
            return file;

          case 9:
            _context2.next = 14;
            break;

          case 11:
            if (!(lastResortFile != null)) {
              _context2.next = 14;
              break;
            }

            _context2.next = 14;
            return lastResortFile;

          case 14:
            _context2.next = 50;
            break;

          case 16:
            if (!(entry.kind === 'directory')) {
              _context2.next = 47;
              break;
            }

            _iteratorAbruptCompletion = false;
            _didIteratorError = false;
            _context2.prev = 19;
            _iterator = _asyncIterator(entry.values());

          case 21:
            _context2.next = 23;
            return _awaitAsyncGenerator(_iterator.next());

          case 23:
            if (!(_iteratorAbruptCompletion = !(_step = _context2.sent).done)) {
              _context2.next = 29;
              break;
            }

            handle = _step.value;
            return _context2.delegateYield(_asyncGeneratorDelegate(_asyncIterator(createPromiseToAddFileOrParseDirectory(handle, "".concat(relativePath, "/").concat(entry.name))), _awaitAsyncGenerator), "t0", 26);

          case 26:
            _iteratorAbruptCompletion = false;
            _context2.next = 21;
            break;

          case 29:
            _context2.next = 35;
            break;

          case 31:
            _context2.prev = 31;
            _context2.t1 = _context2["catch"](19);
            _didIteratorError = true;
            _iteratorError = _context2.t1;

          case 35:
            _context2.prev = 35;
            _context2.prev = 36;

            if (!(_iteratorAbruptCompletion && _iterator.return != null)) {
              _context2.next = 40;
              break;
            }

            _context2.next = 40;
            return _awaitAsyncGenerator(_iterator.return());

          case 40:
            _context2.prev = 40;

            if (!_didIteratorError) {
              _context2.next = 43;
              break;
            }

            throw _iteratorError;

          case 43:
            return _context2.finish(40);

          case 44:
            return _context2.finish(35);

          case 45:
            _context2.next = 50;
            break;

          case 47:
            if (!(lastResortFile != null)) {
              _context2.next = 50;
              break;
            }

            _context2.next = 50;
            return lastResortFile;

          case 50:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2, null, [[19, 31, 35, 45], [36,, 40, 44]]);
  }));
  return _createPromiseToAddFileOrParseDirectory.apply(this, arguments);
}

export default function getFilesFromDataTransfer(_x4, _x5) {
  return _getFilesFromDataTransfer.apply(this, arguments);
}

function _getFilesFromDataTransfer() {
  _getFilesFromDataTransfer = _wrapAsyncGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(dataTransfer, logDropError) {
    var fileSystemHandles, _iterator2, _step2, _ref3, lastResortFile, fileSystemHandle;

    return _regeneratorRuntime.wrap(function _callee4$(_context4) {
      while (1) {
        switch (_context4.prev = _context4.next) {
          case 0:
            _context4.next = 2;
            return _awaitAsyncGenerator(Promise.all(Array.from(dataTransfer.items, /*#__PURE__*/function () {
              var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(item) {
                var _fileSystemHandle, fileSystemHandle, getAsEntry;

                return _regeneratorRuntime.wrap(function _callee3$(_context3) {
                  while (1) {
                    switch (_context3.prev = _context3.next) {
                      case 0:
                        // TODO enable getAsFileSystemHandle API once we can get it working with subdirectories
                        // IMPORTANT: Need to check isSecureContext *before* calling getAsFileSystemHandle
                        // or else Chrome will crash when running in HTTP: https://github.com/transloadit/uppy/issues/4133
                        // if (window.isSecureContext && item.getAsFileSystemHandle != null) entry = await item.getAsFileSystemHandle()
                        // `webkitGetAsEntry` exists in all popular browsers (including non-WebKit browsers),
                        // however it may be renamed to getAsEntry() in the future, so you should code defensively, looking for both.
                        // from https://developer.mozilla.org/en-US/docs/Web/API/DataTransferItem/webkitGetAsEntry
                        getAsEntry = function getAsEntry() {
                          return typeof item.getAsEntry === 'function' ? item.getAsEntry() : item.webkitGetAsEntry();
                        }; // eslint-disable-next-line prefer-const


                        // eslint-disable-next-line prefer-const
                        (_fileSystemHandle = fileSystemHandle) != null ? _fileSystemHandle : fileSystemHandle = getAsFileSystemHandleFromEntry(getAsEntry(), logDropError);
                        return _context3.abrupt("return", {
                          fileSystemHandle: fileSystemHandle,
                          lastResortFile: item.getAsFile() // can be used as a fallback in case other methods fail

                        });

                      case 3:
                      case "end":
                        return _context3.stop();
                    }
                  }
                }, _callee3);
              }));

              return function (_x6) {
                return _ref.apply(this, arguments);
              };
            }())));

          case 2:
            fileSystemHandles = _context4.sent;
            _iterator2 = _createForOfIteratorHelper(fileSystemHandles);
            _context4.prev = 4;

            _iterator2.s();

          case 6:
            if ((_step2 = _iterator2.n()).done) {
              _context4.next = 30;
              break;
            }

            _ref3 = _step2.value;
            lastResortFile = _ref3.lastResortFile;
            fileSystemHandle = _ref3.fileSystemHandle;

            if (!(fileSystemHandle != null)) {
              _context4.next = 25;
              break;
            }

            _context4.prev = 11;
            return _context4.delegateYield(_asyncGeneratorDelegate(_asyncIterator(createPromiseToAddFileOrParseDirectory(fileSystemHandle, '', lastResortFile)), _awaitAsyncGenerator), "t0", 13);

          case 13:
            _context4.next = 23;
            break;

          case 15:
            _context4.prev = 15;
            _context4.t1 = _context4["catch"](11);

            if (!(lastResortFile != null)) {
              _context4.next = 22;
              break;
            }

            _context4.next = 20;
            return lastResortFile;

          case 20:
            _context4.next = 23;
            break;

          case 22:
            logDropError(_context4.t1);

          case 23:
            _context4.next = 28;
            break;

          case 25:
            if (!(lastResortFile != null)) {
              _context4.next = 28;
              break;
            }

            _context4.next = 28;
            return lastResortFile;

          case 28:
            _context4.next = 6;
            break;

          case 30:
            _context4.next = 35;
            break;

          case 32:
            _context4.prev = 32;
            _context4.t2 = _context4["catch"](4);

            _iterator2.e(_context4.t2);

          case 35:
            _context4.prev = 35;

            _iterator2.f();

            return _context4.finish(35);

          case 38:
          case "end":
            return _context4.stop();
        }
      }
    }, _callee4, null, [[4, 32, 35, 38], [11, 15]]);
  }));
  return _getFilesFromDataTransfer.apply(this, arguments);
}